import React from "react";
import "./Etapas.css";

function Etapas() {
  return (
    <div className="etapas-container">
      <h1>
        Com o livro "Pesquisa Científica: Aspectos Práticos", seu trabalho será
        feito em uma sequência de 3 etapas, conhecidas aqui na Insigne Acadêmica
        como Método CRP:
      </h1>
      <div className="etapas-itens">
        <div>
          <h2>Etapa 1</h2>
          <h3>construção</h3>
        </div>
        <div>
          <h2>etapa 2</h2>
          <h3>revisão</h3>
        </div>
        <div>
          <h2>etapa 3</h2>
          <h3>publicação</h3>
        </div>
      </div>

      <p>
        Não existe segredo, nem muito menos fórmula mágica, trata-se apenas de
        um método de escrita científica validado que já ajudou centenas de
        alunos, nos últimos 2 anos, a publicarem os seus trabalhos acadêmicos (a
        prova está na seção abaixo).
      </p>
    </div>
  );
}

export default Etapas;
